// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetNewbuildingPromoSnippetForMapRequest,
  TGetNewbuildingPromoSnippetForMapModel,
  IMappers,
  TGetNewbuildingPromoSnippetForMapResponse,
  IGetNewbuildingPromoSnippetForMapResponse,
} from './types';

export const defaultConfig: TGetNewbuildingPromoSnippetForMapModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'newbuilding-brand-promotion',
  pathApi: '/v1/get-newbuilding-promo-snippet-for-map/',
} as TGetNewbuildingPromoSnippetForMapModel;

export function createGetNewbuildingPromoSnippetForMapModel(
  parameters: IGetNewbuildingPromoSnippetForMapRequest,
): TGetNewbuildingPromoSnippetForMapModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingPromoSnippetForMapOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IGetNewbuildingPromoSnippetForMapRequest;
}

export async function fetchGetNewbuildingPromoSnippetForMap<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingPromoSnippetForMapOptions<TResponse200>): Promise<
  TGetNewbuildingPromoSnippetForMapResponse | TResponse200
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetNewbuildingPromoSnippetForMapModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingPromoSnippetForMapResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetNewbuildingPromoSnippetForMapResponse;
}
